<template>
  <div v-if="this.$route.params.id" class="md-layout-item">
    <md-card>
      <md-card-header
        v-if="this.tableData.length == 0"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon class="load-rotate">hourglass_empty</md-icon>
        </div>
        <h4 class="title">Laden</h4>
      </md-card-header>
      <md-card-header
        v-if="this.tableData.length > 0"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon>article</md-icon>
        </div>
        <h4 class="title">Chauffeur velden</h4>
      </md-card-header>
      <md-card-content>
        <md-table
          v-if="this.tableData.length > 0"
          :value="queriedData"
          :md-sort.sync="currentSort"
          :md-sort-order.sync="currentSortOrder"
          :md-sort-fn="sortAll"
          class="paginated-table table-striped table-hover"
        >
          <md-table-toolbar>
            <md-field>
              <label for="pages">Chauffeur velden per pagina</label>
              <md-select v-model="pagination.perPage" name="pages">
                <md-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                  {{ item }}
                </md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-input
                type="search"
                class="mb-3"
                clearable
                style="width: 200px"
                placeholder="Zoek Chauffeur veld(en)"
                v-model="searchQuery"
              >
              </md-input>
            </md-field>
          </md-table-toolbar>

          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell
              class="cursor-pointer"
              @click.native="handleEdit(item)"
              md-label="Naam"
              md-sort-by="name"
            >
              {{ item.name }}
            </md-table-cell>
            <md-table-cell
              class="cursor-pointer"
              @click.native="handleEdit(item)"
              md-label="Type"
              md-sort-by="type"
            >
              {{ getFieldTypeLabelById(item.type_id) }}
            </md-table-cell>
            <md-table-cell
              class="cursor-pointer"
              @click.native="handleEdit(item)"
              md-label="Volgorde"
              md-sort-by="order"
            >
              {{ item.order }}
            </md-table-cell>
            <md-table-cell md-label="Verwijderen">
              <div class="md-group">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>delete</md-icon>
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
      <md-card-actions
        v-if="this.tableData.length > 0"
        md-alignment="space-between"
      >
        <div class="">
          <p class="card-category">
            Weergave van {{ from + 1 }} t/m {{ to }} van {{ total }} Chauffeur
            velden
          </p>
        </div>
        <pagination
          class="pagination-no-border pagination-success"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        >
        </pagination>
      </md-card-actions>
    </md-card>

    <md-button
      :disabled="addButtonDisabled"
      native-type="button"
      @click.native.prevent="handleAdd"
      class="md-success"
      >Chauffeur veld toevoegen</md-button
    >
  </div>
</template>

<script>
import { Option, Select, Table, TableColumn } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      currentSort: "order",
      currentSortOrder: "asc",
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      fieldTypes: [],
      footerTable: ["Naam", "Type", "Volgorde"],
      searchQuery: "",
      propsToSearch: ["name", "type", "order"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      addButtonDisabled: true
    };
  },
  methods: {
    loadGroupFields() {
      this.addButtonDisabled = true;
      this.$http
        .get(this.$apiBaseUrl + "drivers/fields/group/" + this.$route.params.id)
        .then(
          response => {
            this.tableData = response.data.fields;

            // Fuse search initialization.
            this.fuseSearch = new Fuse(this.tableData, {
              keys: ["name", "type", "order"],
              threshold: 0.3
            });

            this.addButtonDisabled = false;
          },
          response => {
            if (response.status === 403) {
              this.addButtonDisabled = false;
              this.notifyVue(
                "U heeft geen rechten voor het beheren van Chauffeur veld groepen",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    loadFieldTypes() {
      this.addButtonDisabled = true;
      this.$http.get(this.$apiBaseUrl + "drivers/field/types").then(
        response => {
          this.fieldTypes = response.data.fieldTypes;
        },
        response => {
          if (response.status === 403) {
            this.addButtonDisabled = false;
            this.notifyVue(
              "U heeft geen rechten voor het beheren van Chauffeur velden",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    getFieldTypeLabelById(typeId) {
      for (var i in this.fieldTypes) {
        if (this.fieldTypes[i].id == typeId) {
          return this.fieldTypes[i].label;
        }
      }
    },
    handleAdd() {
      this.$router.push(
        "/drivers/group/" + this.$route.params.id + "/field/add"
      );
    },
    handleEdit(item) {
      this.$router.push(
        "/drivers/group/" + this.$route.params.id + "/field/edit/" + item.id
      );
    },
    handleDelete(item) {
      Swal.fire({
        title: "Weet u het zeker?",
        text: `Veld groep "${item.name}" wordt uit het systeem verwijderd.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Verwijderen",
        cancelButtonText: "Annuleren",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$http
            .delete(this.$apiBaseUrl + "drivers/field/group/" + item.id)
            .then(
              response => {
                this.deleteRow(item);

                this.notifyVue(
                  "Veld groep succesvol verwijderd",
                  "check",
                  "success",
                  5000
                );

                // Fuse search initialization.
                this.fuseSearch = new Fuse(this.tableData, {
                  keys: ["name", "type", "order"],
                  threshold: 0.3
                });
              },
              response => {
                if (response.status === 403) {
                  this.notifyVue(
                    "U heeft geen rechten voor het beheren van Chauffeur veld groepen",
                    "add_alert",
                    "danger",
                    0
                  );
                }
              }
            );
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  mounted() {
    this.loadFieldTypes();
    this.loadGroupFields();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-card .md-table-cell.cursor-pointer {
  cursor: pointer;
}
</style>
